module.exports = __webpack_public_path__ + "img/NicolasRman.15693d72.jpg";